import type * as _Interface from './index.barrel.js';

export type { _Interface as Interface };

export type Interface = Readonly<
  _Interface.AddAdsCallbacks &
    _Interface.AddPrebidConfig &
    _Interface.AddAuctionCallbacks &
    _Interface.GetConfigs &
    _Interface.GetInstance &
    _Interface.LoadPrebid
>;
